// Constantes utilizadas no módulo de autenticação

export const REGIONS = {
  RNO: "RNO",
  RCO: "RCO",
  RRD: "RRD"
};

export const MESSAGES = {
  USER_NOT_FOUND: "Usuário Não Encontrado",
  REQUIRED_FIELD: "Campo Necessário",
  LOGIN_SUCCESS: "Login realizado com sucesso",
  NETWORK_ERROR: "Erro de conexão. Verifique sua internet."
};

export const STORAGE_KEYS = {
  TOKEN: "token",
  USER: "user",
  REGION: "region",
  NAME_USER: "nameUser",
  ALL_PLOTS: "allPlots",
  UNIQUE_OCCURRENCES: "uniqueOccurrences",
  OCCURRENCES_SORT: "occurrences-sort",
  REGISTER_PLOT_ALTERNATE: "register-plot-alternate",
  REGISTERS_TO_INVITE: "registers-to-invite"
};

